import { combineReducers } from '@reduxjs/toolkit';
import { createWireDepositSlice } from './wireDeposits/createWireDepositSlice';
import { updateWireDepositSlice } from './wireDeposits/updateWireDepositSlice';
import { deleteWireDepositSlice } from './wireDeposits/deleteWireDepositSlice';
import { createAchDepositSlice } from './achDeposits/createAchDepositSlice';
import { updateAchDepositSlice } from './achDeposits/updateAchDepositSlice';
import { deleteAchDepositSlice } from './achDeposits/deleteAchDepositSlice';
import { sendAchDepositSlice } from './achDeposits/sendAchDepositSlice';
import { createCheckDepositSlice } from './checkDeposits/createCheckDepositSlice';
import { updateCheckDepositSlice } from './checkDeposits/updateCheckDepositSlice';
import { deleteCheckDepositSlice } from './checkDeposits/deleteCheckDepositSlice';

export const depositsReducer = combineReducers({
  // ACH Deposits
  createAchDeposit: createAchDepositSlice.reducer,
  updateAchDeposit: updateAchDepositSlice.reducer,
  deleteAchDepositSlice: deleteAchDepositSlice.reducer,
  sendAchDepositSlice: sendAchDepositSlice.reducer,

  //CheckDeposits
  createCheckDeposit: createCheckDepositSlice.reducer,
  updateCheckDeposit: updateCheckDepositSlice.reducer,
  deleteCheckDepositSlice: deleteCheckDepositSlice.reducer,

  // Wire Deposits
  createWireDeposit: createWireDepositSlice.reducer,
  updateWireDeposit: updateWireDepositSlice.reducer,
  deleteWireDepositSlice: deleteWireDepositSlice.reducer,
});
